import {
  UnderwearCategory,
  UnderwearCategoryType,
} from '@repo/types/src/underwear';
import { z } from 'zod';

const requiredMessage = 'Champ requis';

const [firstUnderwearCategoryKey, ...otherUnderwearCategoryKeys] = Object.keys(
  UnderwearCategory,
) as UnderwearCategoryType[];

export const schema = z.object({
  name: z.string().trim().min(1, requiredMessage),
  nameEn: z.string().trim().optional(),
  file: z.instanceof(File),
  category: z.enum([firstUnderwearCategoryKey, ...otherUnderwearCategoryKeys]),
  sortOrder: z.coerce.number().min(0),
  isAvailableOnOrpair: z.boolean(),
});

export const updateSchema = schema.extend({
  file: z.instanceof(File).optional(),
});

export type UnderwearSchemaType = z.infer<typeof schema>;
export type UpdateUnderwearSchemaType = z.infer<typeof updateSchema>;
